import Vue from 'vue';
import { workPool } from '@wochitnpm/helpers';

export class AssetJobObserver {
  constructor(component) {
    this.component = component;
    this.offJobListeners = new Set();
  }

  stopListening() {
    workPool.off(this.offJobListeners);
  }

  listen() {
    this._onGeneratingPreview();
    this._onTrimmingFragment();
  }

  _onGeneratingPreview() {
    const hasJob = workPool.has({
      type: workPool.job.createAssetPreview.type,
      context: (jc) => jc.assetId === this.component.workModel.id,
    });

    if (hasJob) {
      workPool.once(
        {
          type: workPool.job.createAssetPreview.type,
          context: (jc) => jc.assetId === this.component.workModel.id,
        },
        ({ asset, error, abort }) => {
          console.log({ asset, error, abort });
          if (!error && !abort) {
            Vue.$$set(this.component.workModel, asset);
          }
        },
        this.offJobListeners
      );
    }
  }

  _onTrimmingFragment() {
    const hasJob = workPool.has({
      type: workPool.job.trimVideoFragment.type,
      context: (jc) => jc.assetId === this.component.workModel.id,
    });

    if (hasJob) {
      workPool.once(
        {
          type: workPool.job.trimVideoFragment.type,
          context: (jc) => jc.assetId === this.component.workModel.id,
        },
        ({ asset, error }) => {
          console.log({ asset, error });
          if (!error) {
            Vue.$$set(this.component.workModel, asset);
          }
        },
        this.offJobListeners
      );
    }
  }
}
